import { render, staticRenderFns } from "./member-carrousel-box.vue?vue&type=template&id=b4176d00"
import script from "./member-carrousel-box.vue?vue&type=script&lang=js"
export * from "./member-carrousel-box.vue?vue&type=script&lang=js"
import style0 from "./member-carrousel-box.vue?vue&type=style&index=0&id=b4176d00&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports